// extracted by mini-css-extract-plugin
module.exports = {"errorBlock":"TAq3-vjq_KFIW9PH8MnZe"};